export default __webpack_public_path__ + "static/media/report_alt.a0e944d5.svg";